// extracted by mini-css-extract-plugin
export var container = "_4-0";
export var formArea = "_4-5";
export var formWrapper = "_4-4";
export var fullWidthButton = "_4-6";
export var leftPanel = "_4-1";
export var loadingSpinner = "_4-8";
export var logo = "_4-3";
export var logoLockup = "_4-2";
export var primaryActionButton = "_4-7";
export var spin = "_4-9";